//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {calldeicevideo} from '../../api/device'
export default {
  name: 'videoPage',
  data () {
    return {
      rtcUrl: '',
      deviceData: ''
    }
  },
  created () {
    this.deviceData = this.$store.getters.get_child_obj
    this.getRtcUrl()
  },
  methods: {
    getRtcUrl () {
      let data = {
        deviceid: this.deviceData.deviceid,
        name: this.deviceData.name,
        videotype: 'video' //  类型，video 视频  voice  音频。当前只有video
      }
      calldeicevideo(data).then(res => {
        // res.data.roomid
        this.rtcUrl = 'https://rtc.sdyit.com/websrs/?autostart=true&room=' + 'devicetest'
      }).catch(() => {})
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/device/videoPage.vue